(ns hai.contacts.data
  "Contact mutations behind the detail page and the contacts page. A save
   returns the fresh contact (the editor shape) and stores it at the entity
   ident the detail page reads; the page's collection re-queries its rows when
   mounted, since a paged collection can't be reconciled from one contact.
   Mirrors [[hai.notes.data]]."
  (:require
   [hai.contacts.mutations :as mutations]
   [hai.ui.request :as request]
   [hai.ui.rf-sugar :refer [defevent-fx]]))

(def table-id
  "Collection id of the contacts page. The mutations re-resolve it when mounted."
  ::table)

(defn- contact-ident
  [contact-uuid]
  [:contact/uuid (uuid (str contact-uuid))])

(defn- refresh-fx
  [db]
  (cond-> []
    (get-in db [:collections table-id])
    (conj [:dispatch [:table/resolve table-id]])))

(defevent-fx ::delete [{:keys [db]} contact-uuid]
  {:resolve (assoc (mutations/delete-resolve contact-uuid)
                   :on-success-fx (conj (refresh-fx db)
                                        [:dispatch [:entity/clear {:contact/uuid contact-uuid}]])
                   :on-error-fx [[:dispatch [:toast/error {:text "Could not delete contact. Try again."}]]])})

;; File the composer's staged payload onto an existing contact — one request
;; whose response is the contact as saved.
(defevent-fx ::save-edit [{:keys [db]} contact-uuid staged]
  (let [ident      (contact-ident contact-uuid)
        request-id [::save-edit (second ident)]]
    (when-not (request/in-flight? db request-id)
      {:db (request/mark-in-flight db request-id)
       :resolve (assoc (mutations/save-resolve {:contact/uuid (second ident)} staged)
                       :request-id request-id
                       :store-in ident
                       :on-success-fx (conj (refresh-fx db)
                                            [:dispatch [:toast/success {:text "Contact saved"}]])
                       :on-error-fx [[:dispatch [:toast/error {:text "Could not save contact. Try again."}]]])})))
